import { useCallback, useEffect, useMemo, useState } from 'react';
import { toDatetimeLocalValue } from './formatters';
export function useRedeemCreditsCashForm({ open, playerBalance }) {
    const [creditAmount, setCreditAmount] = useState('');
    const [cashPaid, setCashPaid] = useState('');
    const [receivedAt, setReceivedAt] = useState(() => toDatetimeLocalValue(new Date()));
    const [externalReference, setExternalReference] = useState('');
    const [note, setNote] = useState('');
    const [cashPaidTouched, setCashPaidTouched] = useState(false);
    useEffect(() => {
        if (!open)
            return;
        setCreditAmount('');
        setCashPaid('');
        setCashPaidTouched(false);
        setReceivedAt(toDatetimeLocalValue(new Date()));
        setExternalReference('');
        setNote('');
    }, [open]);
    const creditsNum = useMemo(() => {
        const n = Number(creditAmount);
        return Number.isFinite(n) ? n : 0;
    }, [creditAmount]);
    useEffect(() => {
        if (cashPaidTouched)
            return;
        if (creditsNum > 0)
            setCashPaid(String(creditsNum));
        else
            setCashPaid('');
    }, [creditsNum, cashPaidTouched]);
    const cashPaidNum = useMemo(() => {
        const n = Number(cashPaid);
        return Number.isFinite(n) ? n : 0;
    }, [cashPaid]);
    const validationError = useMemo(() => {
        if (!creditsNum || creditsNum <= 0)
            return 'Enter a valid credit amount';
        if (playerBalance != null && creditsNum > playerBalance) {
            return 'Redeem amount cannot exceed player balance';
        }
        if (!cashPaidNum || cashPaidNum <= 0)
            return 'Enter cash paid to player';
        if (!receivedAt)
            return 'Received at is required';
        return null;
    }, [creditsNum, cashPaidNum, receivedAt, playerBalance]);
    const buildSubmitValues = useCallback(() => {
        if (validationError)
            return null;
        return {
            creditAmount: creditsNum,
            cashPaid: cashPaidNum,
            receivedAt: new Date(receivedAt).toISOString(),
            externalReference: externalReference.trim() || undefined,
            note: note.trim() || undefined,
        };
    }, [validationError, creditsNum, cashPaidNum, receivedAt, externalReference, note]);
    const handleCashPaidChange = useCallback((value) => {
        setCashPaidTouched(true);
        setCashPaid(value);
    }, []);
    return {
        creditAmount,
        setCreditAmount,
        cashPaid,
        setCashPaid: handleCashPaidChange,
        receivedAt,
        setReceivedAt,
        externalReference,
        setExternalReference,
        note,
        setNote,
        creditsNum,
        cashPaidNum,
        validationError,
        buildSubmitValues,
    };
}
